if($('.type-detail').length){
    $('.p-info-wrapper').append($('.p-detail-inner-header').clone())
    $('.add-to-cart').remove()
    $('.detail-parameters tr th:contains("#ORIGINAL-PAGE")').hide()
    if($('.basic-description h3+p').text().match('Popis produktu není dostupný')){
        $('.p-detail-tabs-wrapper').hide()
    }
    else{
        if($('.p-short-description').length){
            $('.p-short-description').append('<p class="moreInfo"><a href="#description" class="" data-toggle="tab" data-external="1" data-force-scroll="true">Všechny informace k produktu</a></p>')
        }
        else{
            
        }
    }
    if($('.detail-parameters tr th:contains("#ORIGINAL-PAGE")')){
        $('.p-info-wrapper').append('<div class="cartLine"><a href="'+$('.detail-parameters tr th:contains("#ORIGINAL-PAGE")').closest('tr').find('td').text().trim()+'" target="_blank">Zobrazit v katalogu</a></div>')
    }
    else{
        $('.p-info-wrapper').append('<div class="cartLine"></div>')
    }
    if (!sessionStorage.getItem('HoffmannProducts')) {
        $.ajax({
            url: '/user/documents/products.json?v=' + new Date().getMinutes(),
            type: 'GET',
            dataType: 'json',
            success: function(data) {
                var processedProducts = data.map(function(product) {
                    if (product.VARIANTS && product.VARIANTS.VARIANT) {
                        var variantsArray = Array.isArray(product.VARIANTS.VARIANT) ? product.VARIANTS.VARIANT : [product.VARIANTS.VARIANT];
                        var codes = variantsArray.map(function(variant) {
                            return variant.CODE;
                        });
                        var codesString = codes.join(',');
                        product.VARIANTS = codesString;
                    }        
                    return product;
                });
              
                sessionStorage.setItem('HoffmannProducts', JSON.stringify(processedProducts));
                productDetail();
            },
            error: function() {
                console.error('Chyba při načítání dat');
            }
        });
    } else {
        console.log('Data již byla načtena a uložena ve storage.');
        productDetail();
    }

    function productDetail(){
        $(document).ready(function() {
            var productsData = JSON.parse(sessionStorage.getItem('HoffmannProducts'));
            $('.p-info-wrapper .p-code').each(function() {
                $(this).find('span:not(.p-code-label)').each(function() {
                    var text = $(this).text().trim();
                    if (text && text !== "Zvolte variantu") {
                        var foundProduct = productsData.find(function(product) {
                            return product.VARIANTS.split(',').includes(text);
                        });
                        if (foundProduct && foundProduct.LOGO) {
                            if(!$(this).closest('.p-info-wrapper').find('.markImage').length){
                                if($('a[data-testid="productCardBrandName"]').length){
                                    $(this).closest('.p-info-wrapper').prepend('<div class="markImage"><a href="'+$('a[data-testid="productCardBrandName"]').attr('href')+'"><img src="' + foundProduct.LOGO + '" class="product-logo"></a></div>');
                                }
                                else{
                                    $(this).closest('.p-info-wrapper').prepend('<div class="markImage"><img src="' + foundProduct.LOGO + '" class="product-logo"></div>');
                                }
                                
                            }
                            
                        }
                    }
                });
            });
        });
    }

    if($('.variant-list').length>0){
        if($('.variant-list').find('th .show-tooltip').length){
            var listTootip = $('.variant-list').find('th .show-tooltip').attr('title')
        }
        else{
            listTootip = ''
        }
        $('.variant-list select').each(function(){
            var optionLength = $(this).find('option').length
            var data_parameter_id = $(this).data('parameter-id')
            var html_var = '<div class="custom-variant" data-groupId="'+data_parameter_id+'"><div class="h3">'+$(this).attr('data-parameter-name')+'</div>'
            html_var += '<div class="custom-variant-wrap" data-param-id="'+data_parameter_id+'">'
            $(this).find('option').each(function(){
                var data_value = $(this).attr('value')
                if ($.isNumeric($(this).val())) {
                    var textsplit = $(this).text().split('+')
                    html_var += '<div class="variant" data-value="'+data_value+'" data-parameter-id="'+data_parameter_id+'" data-param-val="'+data_parameter_id+'-'+data_value+'">'
                    html_var += '<div class="text">'
                    if(typeof textsplit[1] === 'undefined'){
                        html_var += textsplit[0]
                    }
                    else{
                        html_var += textsplit[0]+' (+'+textsplit[1]+')'
                    }
                  
                    if(listTootip !== ''){
                        if(textsplit[1] !== '0 Kč'){
                            html_var += '<span class="show-tooltip question-tooltip" title="'+listTootip+'">?</span>'
                        }
                    }
                    html_var += '</div>'
                    html_var += '</div>'
                }
            })
            html_var += '</div></div>'
            $(this).after(html_var)
            $(this).closest('.variant-list select').hide()
           $(this).closest('.variant-list span').hide()
          
        })

        var necessaryVariantData = shoptet.variantsSplit.necessaryVariantData;
        for (var parentKey in necessaryVariantData) {
            if (necessaryVariantData.hasOwnProperty(parentKey)) {
                var variant = necessaryVariantData[parentKey];
               
                $('.custom-variant-wrap .variant[data-param-val="'+parentKey+'"]').attr('data-price-id', variant.id).attr('data-avail', variant.availabilityName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ /g, '-'))
                $('.custom-variant-wrap .variant[data-param-val="'+parentKey+'"]').append('<div class="stockPoint"><span style="background-color:'+variant.availabilityColor+'"></span></div>')
            }
        }
    }

    $(document).on('click', '.custom-variant-wrap .variant', function(){
        const variantData = $(this).data('value');
        const variantParameterId = $(this).data('parameter-id');
    
        // Změna pro data-parameter-id 281 a třídu active
        if($(this).attr('data-parameter-id') === '281' && $(this).hasClass('active')){
            $("select[data-parameter-id='281'] option:first").prop("selected", true).change();
            $(this).removeClass("active"); 
        } else {
            // Původní chování pro ostatní případy
            $("select[data-parameter-id='"+variantParameterId+"'] option").filter(function (){
                return $(this).attr('value') == variantData;
            }).change().prop("selected", true);
            $(this).closest('.custom-variant-wrap[data-param-id="'+variantParameterId+'"]').find(".variant:not([data-value='"+variantData+"'])").removeClass("active");
            $(this).addClass("active"); 
        }
    
        var selector = '.variant-list .hidden-split-parameter, .variant-list .split-parameter';
        var $splitParameters = $(selector);
        $splitParameters.trigger('change');
    
       // $(this).closest('.custom-variant-wrap[data-param-id="'+variantParameterId+'"]').find(".variant:not([data-value='"+variantData+"'])").removeClass("active");
       // $(this).addClass("active");    
    
        $("select[data-parameter-id='"+variantParameterId+"']")[0].dispatchEvent(new Event('change'));
    
        $('.custom-variant-wrap .variant').each(function(){
            const variantData = $(this).data('value');
            const variantParameterId = $(this).data('parameter-id');
            const unavailable = $("select[data-parameter-id='"+variantParameterId+"'] option[value='" + variantData + "']").hasClass("unavailable-option");
            if (unavailable === true) {
                $(this).addClass("unavailable").removeClass("active");
            }
            else{
                $(this).removeClass("unavailable");
            } 
        });
    });

}